import Electron from "@/App/Electron";
import useElectronHook from "@/shared/hooks/useElectronHook";
import useIsWaiter from "@/shared/hooks/useIsWaiter";
import useRoleHooks from "@/shared/hooks/useRoleHooks";
import { userRoles } from "@/shared/utils/constant";
import AdminGlobal from "../AdminGlobal";
import ProtectedLayoutLive from "../Layout/ProtectedLayoutLive";
import Pusher from "../Pusher";
import Formules from "./Formules";
import NewOrdersModal from "./NewOrdersModal";
import WaiterGlobal from "./WaiterGlobal";
import KioskGlobal from "./KioskGlobal";
import SystemMessageGlobal from "./SystemMessageGlobal";

const AuthGlobal = () => {
  const { hasAuthority } = useRoleHooks(false);
  const { isElectron } = useElectronHook();

  return (
    <>
      {hasAuthority(userRoles.ROLE_ORDER_TRACKER) && <NewOrdersModal />}
      {hasAuthority(userRoles.ROLE_ORDER_TRACKER) && <Formules />}
      {isElectron && <Electron />}
      {hasAuthority(userRoles.ROLE_ORDER_TRACKER) && <Pusher />}
      {hasAuthority(userRoles.ROLE_ORDER_TRACKER) && <ProtectedLayoutLive />}
      {hasAuthority(userRoles.ROLE_ADMIN) && <AdminGlobal />}
      {
        // hasAuthority(userRoles.ROLE_WAITER)
        useIsWaiter() && <WaiterGlobal />
      }
      {/* For kiosk add kiosk role in the future */}
      <KioskGlobal />
      <SystemMessageGlobal />
    </>
  );
};

export default AuthGlobal;
